import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { LocationDetailsMap } from 'src/locations/LocationDetailsMap';
import { NoLocation } from 'src/locations/NoLocation';
import { fetchRSim } from 'src/rSimInventory/RSimApi/rSimApi';
import { fetchSimInventoryEntry } from 'src/simInventory/SimInventoryApi/simInventoryApi';

type RSimLocationDetailsMapProps = {
  euicc: string;
};

export const RSimLocationDetailsMap: FC<RSimLocationDetailsMapProps> = (props) => {
  const { euicc } = props;

  const { data, status, fetchStatus } = useQuery({
    queryKey: ['locations', 'map', 'rsim-imsi', euicc],
    queryFn: async ({ signal }) => {
      const rsimsDetails = await fetchRSim(euicc, signal);
      const rsimDetails = rsimsDetails.items[0];

      if (!rsimDetails) {
        throw new Error('NoRsimForEuicc');
      }

      const activeIccid =
        rsimDetails.lastActiveProfile === 1 ? rsimDetails.primaryIccid : rsimDetails.secondaryIccid;

      if (!activeIccid) {
        throw new Error('NoActiveIccidForRsim');
      }

      return fetchSimInventoryEntry(activeIccid, undefined, signal);
    },
    enabled: !!euicc,
    meta: {
      isLocationsDetails: true,
    },
  });

  const parentInitialPending = status === 'pending' && fetchStatus === 'fetching';
  const parentError = status === 'error';

  if (status === 'success' && !data.imsi) {
    return <NoLocation />;
  }

  return (
    <LocationDetailsMap
      imsi={data?.imsi ?? ''}
      parentInitialPending={parentInitialPending}
      parentError={parentError}
    />
  );
};
